module.exports = __webpack_public_path__ + "img/anadir-archivo.e9c26a3b.svg";